import { render, staticRenderFns } from "./EditDomains.vue?vue&type=template&id=77b28214&"
import script from "./EditDomains.vue?vue&type=script&lang=js&"
export * from "./EditDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports